import 'reflect-metadata';
import { Component, Inject } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { MatIconRegistry } from '@angular/material/icon';
import { ConsoleToggleService } from './core/services/consoleToggleService.service';
import { IconService } from './core/services/icon.service';
import { APP_CONFIG } from './config/app-config';
import { StorageService } from './core/services/storage.service';
// import { SpinnerOverlayService } from './core/services/spinner-overlay.service';
// import { LoaderService } from './core/services/loader.service';

@Component({
    selector: 'itfg-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  title = 'app';

  constructor(
    private translate: TranslateService,
    public matIconRegistry: MatIconRegistry,
    private consoleToggleService: ConsoleToggleService,
    private iconService: IconService
    // private loader: LoaderService,
    // private spinnerOverlay: SpinnerOverlayService,
  ) {
    // this.loader.loadingBus$.subscribe((isLoading: boolean) => { // uncomment to enable overlay loader
    //   if (isLoading) {
    //     this.spinnerOverlay.show();
    //   } else {
    //     this.spinnerOverlay.hide();
    //   }
    // })

    const storage = new StorageService(APP_CONFIG.AUTH.STORAGE_TYPE);
    const storedLanguage = storage.getItem('translationLanguage');

    if (storedLanguage) {
      const userMedia = navigator.userAgent.toLowerCase();
      if (userMedia.indexOf('edge') !== -1) {
        setTimeout(() => {
          this.translate.use(storedLanguage);
        }, 1000);
      } else {
        this.translate.use(storedLanguage);
      }
    } else {
      this.translate.use('bg');
    }

    this.iconService.registerIcons();
    this.consoleToggleService.disableConsoleInProduction();
    matIconRegistry.registerFontClassAlias('fontawesome', 'fa');
    matIconRegistry.registerFontClassAlias('fontawesome', 'fas');
  }
}
